import React, { useState, useEffect } from "react";
import Timer from "./Timer";
import "./../styles/TaskDetailsBox.css";
import Countdown from "react-countdown";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

export const TaskDetailsBox = (props) => {
  const ReceivedDate = "2022-09-21"; //props.taskData[0].receivedDate;
  const StartDate = "2022-09-21"; // props.taskData[0].startTime;
  const [displayReady, setDisplayReady] = useState(false);
  var TaT;
  var x;

  function LoadData() {
    //var TaT;
    console.log(ReceivedDate);
    if (props.ocrData.Prioritization == "Standard") {
      var dt = new Date(ReceivedDate);
      var addMlSeconds = 72 * 60 * 60 * 1000;

      TaT = dt.setHours(dt.getHours() + 72);

      // var difference = dt - new Date();

      // var timeLeft = {
      //     days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      //     hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      //     minutes: Math.floor((difference / 1000 / 60) % 60),
      //     seconds: Math.floor((difference / 1000) % 60)
      //   };

      // TaT = timeLeft;
      x = Date.now();
      var y = new Date(TaT);
    }

    //

    setDisplayReady(true);
    console.log("---------");
  }
  useEffect(() => {
    LoadData();
  }, []);

  if (displayReady) {
    return (
      <div className="task-details">
        <div className="timer">
          <label>
            <AccountCircleOutlinedIcon /> Task ID :{" "}
            {sessionStorage.getItem("ActiveTaskID")}
          </label>
        </div>
        <div className="timer">
          <label>
            <LocalHospitalIcon /> Auth ID : {props.authId}
          </label>
        </div>
        <div className="timer">
          {/* {props.completedTime != 3 ? ( */}
          {props.taskStatus != 3 ? (
            <label id="timeSpent">
              <AccessTimeOutlinedIcon /> Time Spent :{" "}
              <Timer start={Date.now()} />
            </label>
          ) : (
            <label>
              <AccessTimeOutlinedIcon /> Completed
            </label>
          )}
        </div>

        {/* <div className="timer"><label id="Tat">Turn Around Time <Countdown date={TaT + 1}></Countdown></label></div> */}
      </div>
    );
  } else {
    return <></>;
  }
};
